import { getStyle } from './getStyle';
import { getVSMEText } from '../../../../main/functions/vsme/getVSMEText';
import { IDs } from '../../../../helpers/IDs';
import * as React from 'react';
import { renderTable } from './renderTable';
import { Table } from './Table';
import { WpdfText } from '../../pdf/WpdfText.';
import { WpdfView } from '../../pdf/WpdfView';

export interface ModulBpmProps {
    data: any;
    isPdf?: boolean;
    jahr: number;
    standortTid?: number;
    getPageNum?: (key: string, page: number, level: number) => void;
}

export class ModulBpm extends React.Component<ModulBpmProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {
        };
        this.init();
    }

    private flags: any;
    private formatFloat: any = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2, useGrouping: true });
    private isAvailable: boolean;
    private platzhalter: any;
    private Table: any;

    componentDidUpdate(prevProps: any): void {
        if (this.props.standortTid !== prevProps.standortTid || this.props.jahr !== prevProps.jahr) {
            this.init();
        }
    }

    init(): void {
        const { data, jahr, standortTid } = this.props;
        const b1: any = ((this.props.data || {})[IDs.ENT_VSME_B1] || [])
            .find((item: any) => (item.standort_tid_orig || item.standort_tid) === this.props.standortTid) || {};
        this.isAvailable = Object.keys(b1).length ? (b1.modul === 'basis_geschaeft' || b1.modul === 'basis_pat_geschaeft') : true;
        this.Table = new Table(this.props.data, { jahr: this.props.jahr, standort_tid: this.props.standortTid });
        this.flags = ((((data[IDs.KENNZIFFERN_BERECHNET] || {})[jahr] || {}).vsme || {})[standortTid] || {}).flags || {};
        this.platzhalter = ((((data[IDs.KENNZIFFERN_BERECHNET] || {})[jahr] || {}).vsme || {})[standortTid] || {}).platzhalter || {};
    }

    isNumber(value: number): boolean {
        return typeof value === 'number' && !isNaN(value);
    }

    render(): JSX.Element {
        if (!this.isAvailable) {
            return null;
        }
        const { isPdf } = this.props;

        return (
            <WpdfView pdf={isPdf} break>
                {this.renderHeading('III) BPM-Modul', 1)}
                {this.renderBP1()}
                {this.renderBP2()}
                {this.renderBP3()}
                {this.renderBP4()}
                {this.renderBP5()}
                {this.renderBP6()}
                {this.renderBP7()}
                {this.renderBP8()}
                {this.renderBP9()}
                {this.renderBP10()}
                {this.renderBP11()}
            </WpdfView>
        );
    }

    renderAbsatz(keys: string[]): JSX.Element {
        const { data, isPdf, jahr, standortTid } = this.props;

        return (
            <WpdfView style={getStyle('div')} pdf={isPdf}>
                <WpdfText pdf={isPdf}>
                    {(keys || []).map((key: string) => getVSMEText(key, data, jahr, standortTid) || '').join(' ')}
                </WpdfText>
            </WpdfView>
        );
    }

    renderBP1(): JSX.Element {
        const { isPdf } = this.props;
        const Table = this.Table;
        const table: any = {
            rows: [['Sektor', 'Einkünfte in €']],
            rowStyles: [[[['head', 'bold'], { flexBasis: '70%' }], [['head', 'bold'], { flexBasis: '30%' }]]]
        };
        const names: any = {
            umstrittene_waffen_einkuenfte: 'umstrittene Waffen (wie Antipersonenminen, Streumunition, chemische und biologische Waffen)',
            tabak_einkuenfte: 'Anbau und Erzeugung von Tabak',
            kohle_einkuenfte: 'Kohle (einschließlich Exploration, Bergbau, Gewinnung, Produktion, Verarbeitung, Lagerung, Raffination oder Vertrieb, Transport, Lagerung und Handel)',
            oel_einkuenfte: 'Öl (einschließlich Exploration, Bergbau, Gewinnung, Produktion, Verarbeitung, Lagerung, Raffination oder Vertrieb, Transport, Lagerung und Handel)',
            gas_einkuenfte: 'Gas (einschließlich Exploration, Bergbau, Gewinnung, Produktion, Verarbeitung, Lagerung, Raffination oder Vertrieb, Transport, Lagerung und Handel)',
            chemikalien_einkuenfte: 'Herstellung von Pestizide, Schädlingsbekämpfungs-, Pflanzenschutz- und Desinfektionsmitteln (Chemikalien, die in der Abteilung 20.2 des Anhangs I der Verordnung (EG) Nr. 1893/2006 aufgeführten sind)'
        };
        const getValue = (key: string, item: any) => this.isNumber(item[key]) ? this.formatFloat.format(item[key]) : item[key];
        Table.processData((IDs.ENT_VSME_BPM1), null, (item: any) => {
            Object.keys(names).forEach((key: string) => {
                if (typeof item[key] === 'undefined') {
                    return;
                }
                table.rows.push([names[key], getValue(key, item)]);
                table.rowStyles.push([{ flexBasis: '70%' }, ['top', { flexBasis: '30%' }]]);
            });
        });

        return <>
            {this.renderHeading('BP1: Einkünfte aus bestimmten Sektoren', 2)}
            {this.renderAbsatz(['bp1_absatz1'])}
            {table.rows.length > 1 && renderTable(table, isPdf)}
        </>;
    }

    renderBP2(): JSX.Element {
        return <>
            {this.renderHeading('BP2: Geschlechtervielfalt (Leitungsorgane)', 2)}
            {this.renderAbsatz(['bp2_absatz1'])}
        </>;
    }

    renderBP3(): JSX.Element {
        return <>
            {this.renderHeading('BP3: Reduzierung von Emissionen: Ziele', 2)}
            {this.renderAbsatz(['bp3_absatz1'])}
        </>;
    }

    renderBP4(): JSX.Element {
        const Table = this.Table;
        let text: JSX.Element = null;
        Table.processData((IDs.ENT_VSME_BPM4), null, (item: any) => {
            if (typeof item.massnahmen === 'string') {
                text = this.renderText(item.massnahmen);
            }
        });

        return <>
            {this.renderHeading('BP4: Klimaschutz: Übergangsplan', 2)}
            {this.renderAbsatz(['bp4_absatz1'])}
            {text}
        </>;
    }

    renderBP5(): JSX.Element {
        return <>
            {this.renderHeading('BP5: Klimawandel: Physikalische Risiken', 2)}
            {this.renderBP5a()}
            {this.renderAbsatz(['bp5_absatz2'])}
            {this.renderBP5c()}
            {this.renderBP5d()}
        </>;
    }

    renderBP5a(): JSX.Element {
        const { isPdf } = this.props;
        const Table = this.Table;
        const table: any = { rows: [], rowStyles: [] };
        const ranges: any = {
            kurz: 'Betrachtung von bis zu einem Jahr', mittel: 'Betrachtung der nächste zwei bis fünf Jahren',
            lang: 'Betrachtung von mehr als fünf Jahren'
        };
        const names: any = {
            gesamtvermoegensanteil_kurz_akut_euro: 'Akute Risiken für Vermögenswerte in €',
            gesamtvermoegensanteil_kurz_akut_prozent: 'Akute Risiken für Vermögenswerte in %',
            gesamtvermoegensanteil_kurz_chronisch_euro: 'Chronische Risiken für Vermögenswerte in €',
            gesamtvermoegensanteil_kurz_chronisch_prozent: 'Chronische Risiken für Vermögenswerte in %'
        };
        const getValue = (key: string, item: any) => this.isNumber(item[key]) ? this.formatFloat.format(item[key]) : item[key];
        Table.processData((IDs.ENT_VSME_BPM5), null, (item: any) => {
            Object.keys(ranges).forEach((range: string) => {
                table.rows.push([ranges[range]]);
                table.rowStyles.push([[['head', 'bold']]]);

                Object.keys(names).forEach((key: string) => {
                    const rangeKey: string = key.replace('kurz', range);

                    if (typeof item[rangeKey] === 'undefined') {
                        return;
                    }
                    table.rows.push([names[key], getValue(rangeKey, item)]);
                    table.rowStyles.push([{ flexBasis: '70%' }, ['top', { flexBasis: '30%' }]]);
                });
            });
        });

        return table.rows.length ? <>{this.renderAbsatz(['bp5_absatz1'])}{renderTable(table, isPdf)}</> : null;
    }

    renderBP5c(): JSX.Element {
        const { isPdf } = this.props;
        const Table = this.Table;
        const table: any = {
            rows: [['wesentliche Vermögenswerte', 'Art des physischen Risikos']],
            rowStyles: [[['head', 'bold'], ['head', 'bold']]]
        };
        Table.processData((IDs.ENT_VSME_BPM5_C), null, (item: any) => {
            table.rows.push([item.vermoegenswert || '', item.risiko || '']);
            table.rowStyles.push(['top', 'top']);
        });

        return table.rows.length > 1 ? <>{this.renderAbsatz(['bp5_absatz3'])}{renderTable(table, isPdf)}</> : null;
    }

    renderBP5d(): JSX.Element {
        const { isPdf } = this.props;
        const Table = this.Table;
        const table: any = { rows: [], rowStyles: [] };
        const ranges: any = {
            kurz: 'Betrachtung von bis zu einem Jahr', mittel: 'Betrachtung der nächste zwei bis fünf Jahren',
            lang: 'Betrachtung von mehr als fünf Jahren'
        };
        const names: any = {
            einnahmensanteil_kurz_netto_euro: 'Anteil an Einnahmen (netto) in €',
            einnahmensanteil_kurz_netto_prozent: 'Anteil an Einnahmen (netto) in %'
        };
        const getValue = (key: string, item: any) => this.isNumber(item[key]) ? this.formatFloat.format(item[key]) : item[key];
        Table.processData((IDs.ENT_VSME_BPM5), null, (item: any) => {
            Object.keys(ranges).forEach((range: string) => {
                table.rows.push([ranges[range]]);
                table.rowStyles.push([[['head', 'bold']]]);

                Object.keys(names).forEach((key: string) => {
                    const rangeKey: string = key.replace('kurz', range);

                    if (typeof item[rangeKey] === 'undefined') {
                        return;
                    }
                    table.rows.push([names[key], getValue(rangeKey, item)]);
                    table.rowStyles.push([{ flexBasis: '70%' }, ['top', { flexBasis: '30%' }]]);
                });
            });
        });

        return table.rows.length ? <>{this.renderAbsatz(['bp5_absatz4'])}{renderTable(table, isPdf)}</> : null;
    }

    renderBP6(): JSX.Element {
        return <>
            {this.renderHeading('BP6: Gefährliche / Radioaktive Abfälle', 2)}
            {this.flags['bp6'] ? this.renderAbsatz(['bp6_absatz1']) : this.renderAbsatz(['bp6_absatz1_v2'])}
        </>;
    }

    renderBP7(): JSX.Element {
        const { isPdf } = this.props;
        const Table = this.Table;
        const table: any = { rows: [], rowStyles: [] };
        const names: any = {
            recht_sicheres_gesundes_arbeitsumfeld: 'Wird das Recht auf ein sicheres und gesundes Arbeitsumfeld eingehalten?',
            vereinigungsfreiheit: 'Wird das Recht auf Vereinigungsfreiheit eingehalten?',
            recht_tarifverhandlungen: 'Wird das Recht auf Tarifverhandlungen eingehalten?',
            beseitigung_diskriminierung: 'Gibt es Maßnahmen zur Beseitigung von Diskriminierung?',
            recht_entgelt_arbeit: 'Wird das Recht auf gleiches Entgelt für gleichwertige Arbeit eingehalten?',
            keine_kinder_zwangsarbeit: 'Wird sichergestellt, dass es keine Kinder- und Zwangsarbeit gibt?',
            un_leitprinzipien: 'Werden die UN-Leitprinzipien für Wirtschaft und Menschenrechte eingehalten?',
            iao_prinzipien_rechte: 'Wird die IAO-Erklärung über grundlegende Prinzipien und Rechte bei der Arbeit eingehalten?',
            oecd_leitsaetze: 'Werden die OECD-Leitsätze für multinationale Unternehmen eingehalten?',
            schulungen_menschenrechte: 'Werden Schulungen der Mitarbeitenden zum Thema Menschenrechte durchgeführt?',
            erfassung_lieferketten: 'Gibt es Bemühungen zur Erfassung der Lieferketten, um proaktiv nach Problemen im Zusammenhang mit Kinderarbeit oder Zwangsarbeit zu suchen, insbesondere in risikoreicheren Bereichen?',
            vereinbarungen_leitlinien: 'Wurden im Rahmen der Geschäftstätigkeit und -beziehungen entsprechende vertragliche Vereinbarungen, Konventionen, Grundsätze oder Leitlinien vereinbart/entwickelt?'
        };
        Table.processData((IDs.ENT_VSME_BPM7), null, (item: any) => {
            Object.keys(names).forEach((key: string) => {
                const infoKey: string = `${key}_info`;

                if (typeof item[key] === 'undefined' || typeof item[infoKey] === 'undefined') {
                    return;
                }
                table.rows.push([names[key], item[key] || '']);
                table.rowStyles.push([[['head', 'bold'], { flexBasis: '90%' }], ['top', { flexBasis: '10%' }]]);
                table.rows.push([item[infoKey] || 'keine Angaben']);
                table.rowStyles.push([]);
            });
        });

        return <>
            {this.renderHeading('BP7: Int. Arbeits- und Menschenrechte', 2)}
            {this.renderAbsatz(['bp7_absatz1'])}
            {renderTable(table, isPdf, true)}
        </>;
    }

    renderBP8(): JSX.Element {
        return <>
            {this.renderHeading('BP8: Überwachung der Einhaltung der Vorschriften/Mechanismen bzgl. Verstößen', 2)}
            {this.renderBP8a()}
            {this.renderBP8b()}
        </>;
    }

    renderBP8a(): JSX.Element {
        const { isPdf } = this.props;
        const Table = this.Table;
        const table: any = { rows: [], rowStyles: [] };
        const names: any = {
            un_leitprinzipien: 'UN-Leitprinzipien für Wirtschaft und Menschenrechte (einschließlich der in der Internationalen Menschenrechtskonvention festgelegten Grundsätze und Rechte)',
            iao_prinzipien_rechte: 'IAO-Erklärung über grundlegende Prinzipien und Rechte bei der Arbeit (einschließlich der in den 8 grundlegenden Übereinkommen der IAO Erklärung und der Internationalen Menschenrechtskonvention niedergelegten Grundsätze und Rechte)',
            oecd_leitsaetze: 'OECD-Leitsätze für multinationale Unternehmen'
        };
        Table.processData((IDs.ENT_VSME_BPM8), null, (item: any) => {
            Object.keys(names).forEach((key: string) => {
                const infoKey: string = `${key}_info`;

                if (typeof item[infoKey] === 'undefined' || (item[`${key}_orig`] || item[key]) !== 1) {
                    return;
                }
                table.rows.push([names[key]]);
                table.rowStyles.push([['head', 'bold']]);
                table.rows.push([item[infoKey] || 'keine Angaben']);
                table.rowStyles.push([]);
            });
        });

        return table.rows.length
            ? <>{this.renderAbsatz(['bp8_absatz1_v1'])}{renderTable(table, isPdf, true)}</>
            : this.renderAbsatz(['bp8_absatz1_v2']);
    }

    renderBP8b(): JSX.Element {
        const { isPdf } = this.props;
        const Table = this.Table;
        const table: any = { rows: [], rowStyles: [] };
        const names: any = {
            anzeigemoeglichkeit_menschenrechtsverletzungen: 'Mitarbeitende haben die Möglichkeit, Menschenrechtsverletzungen oder entsprechende Bedenken anzuzeigen durch Klage-, Beschwerde- oder Whistleblower-Mechanismen.',
            anzeigemoeglichkeit_arbeitsrechtsverstoesse: 'Diese Möglichkeiten bestehen auch für Verstöße gegen Arbeitsrechte.'
        };
        Table.processData((IDs.ENT_VSME_BPM8), null, (item: any) => {
            Object.keys(names).forEach((key: string) => {
                const infoKey: string = `${key}_info`;

                if (typeof item[key] === 'undefined' || typeof item[infoKey] === 'undefined') {
                    return;
                }
                table.rows.push([names[key], item[key] || '']);
                table.rowStyles.push([[['head', 'bold'], { flexBasis: '90%' }], ['top', { flexBasis: '10%' }]]);
                table.rows.push([item[infoKey] || 'keine Angaben']);
                table.rowStyles.push([]);
            });
        });

        return table.rows.length
            ? renderTable(table, isPdf, true)
            : this.renderAbsatz(['bp8_absatz2']);
    }

    renderBP9(): JSX.Element {
        const { isPdf } = this.props;
        const Table = this.Table;
        const table: any = { rows: [], rowStyles: [] };
        const names: any = {
            un_leitprinzipien: 'UN-Leitprinzipien für Wirtschaft und Menschenrechte (einschließlich der in der Internationalen Menschenrechtskonvention festgelegten Grundsätze und Rechte)',
            iao_prinzipien_rechte: 'IAO-Erklärung über grundlegende Prinzipien und Rechte bei der Arbeit (einschließlich der in den 8 grundlegenden Übereinkommen der IAO Erklärung und der Internationalen Menschenrechtskonvention niedergelegten Grundsätze und Rechte)',
            oecd_leitsaetze: 'OECD-Leitsätze für multinationale Unternehmen'
        };
        Table.processData((IDs.ENT_VSME_BPM9), null, (item: any) => {
            Object.keys(names).forEach((key: string) => {
                const infoKey: string = `${key}_info`;

                if (typeof item[key] === 'undefined' || typeof item[infoKey] === 'undefined') {
                    return;
                }
                table.rows.push([names[key], item[key] || '']);
                table.rowStyles.push([[['head', 'bold'], { flexBasis: '90%' }], ['top', { flexBasis: '10%' }]]);
                table.rows.push([item[infoKey] || 'keine Angaben']);
                table.rowStyles.push([]);
            });
        });

        return <>
            {this.renderHeading('BP9: Verstöße gegen die OECD-Leitsätze oder die UN-Leitprinzipien', 2)}
            {!!table.rows.length && <>{this.renderAbsatz(['bp9_absatz3'])}{renderTable(table, isPdf, true)}</>}
            {!table.rows.length && this.renderAbsatz(['bp9_absatz1'])}
        </>;
    }

    renderBP10(): JSX.Element {
        return <>
            {this.renderHeading('BP10: Vereinbarkeit Berufs-/Privatleben', 2)}
            {this.renderAbsatz(['bp10_absatz1'])}
        </>;
    }

    renderBP11(): JSX.Element {
        return <>
            {this.renderHeading('BP11: Anzahl der Auszubildenden', 2)}
            {this.renderAbsatz(['bp11_absatz1'])}
        </>;
    }

    renderHeading(name: string, level: number): JSX.Element {
        const { getPageNum, isPdf } = this.props;
        const style: React.CSSProperties = level === 1
            ? { ...getStyle('h1'), ...(isPdf && { marginTop: 0 }) }
            : (level === 2 ? getStyle('h2') : {});

        return (
            <WpdfView style={style} pdf={isPdf}>
                <WpdfText
                    pdf={isPdf}
                    getPageNum={(pageNumber: number) => typeof getPageNum === 'function' && getPageNum(name, pageNumber, level)}
                >
                    {name || ''}
                </WpdfText>
            </WpdfView>
        );
    }

    renderText(text: string): JSX.Element {
        const { isPdf } = this.props;

        return (
            <WpdfView style={getStyle('div')} pdf={isPdf}>
                <WpdfText pdf={isPdf}>
                    {text}
                </WpdfText>
            </WpdfView>
        );
    }
}
